import React, { useEffect } from 'react'
import Modal from '@components/common/modal'
import VideoModal from '@components/common/video-modal'
import { Trans } from '@lingui/macro'
import { Play } from 'react-feather'
import { FastlyImage } from '@components/common/image'
import { CurriculumVideoType } from '@components/locale-pages/home/courses'

type Props = {
  isModalOpen: boolean
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>
  curriculumVideo: CurriculumVideoType[]
  courseTitle: React.ReactNode
  videoModalOpen: boolean
  setVideoModalOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const CourseVideoModal = ({
  isModalOpen,
  setIsModalOpen,
  curriculumVideo,
  courseTitle,
  videoModalOpen,
  setVideoModalOpen,
}: Props) => {
  const [videoURL, setVideoURL] = React.useState<string>(
    curriculumVideo[0]?.url
  )

  useEffect(() => {
    if (curriculumVideo.length == 1) {
      setVideoURL(curriculumVideo[0]?.url)
    }
  }, [curriculumVideo])

  return (
    <>
      <Modal
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
        isCrossIconShown
        width="w-full lg:max-w-5xl"
      >
        <div
          className="py-2 mb-8 sm:mb-0"
          style={{ maxHeight: 'calc(100vh - 10rem)' }}
        >
          <div className="flex flex-col space-y-10 text-center">
            <h3 className="text-2xl font-600 text-grey leading-tight">
              <Trans>Watch {courseTitle} course intro by grade</Trans>
            </h3>
            <div className="flex justify-center gap-3 space-between flex-wrap py-4 pb-6 md:pb-4">
              {curriculumVideo.map((video) => (
                <button
                  key={video.altText}
                  className="flex flex-col items-center"
                  onClick={(e) => {
                    e.stopPropagation()
                    e.preventDefault()
                    setIsModalOpen(false)
                    setVideoURL(video.url)
                    setVideoModalOpen(true)
                  }}
                >
                  <div className="relative">
                    <FastlyImage
                      src={`/images/courses/video-thumbnail/${video.image}.jpg`}
                      alt={video.altText}
                      width={301}
                      height={168}
                      className="mb-2 rounded-md"
                    />
                    <button className="absolute w-full h-full z-20 bottom-0 flex group focus:outline-none">
                      <span className="p-3 bg-white bg-opacity-75 m-auto rounded-full group-hover:shadow-lg group-hover:bg-orange">
                        <Play size={16} fill="#000" />
                      </span>
                    </button>
                  </div>
                  <span className="text-base lg:text-xl">
                    <Trans>Grade</Trans> {video.grades}
                  </span>
                </button>
              ))}
            </div>
          </div>
        </div>
      </Modal>
      <VideoModal
        isOpen={videoModalOpen}
        setIsOpen={setVideoModalOpen}
        videoURL={videoURL}
      />
    </>
  )
}

export default CourseVideoModal
